module.exports = __webpack_public_path__ + "img/PumpWithoutVFD.700ffaf0.png";